/* linked-products.js: present other products' variants inside this product's page as one
   picker. Reads #linked-products-config (custom.linked_products metafield).

   TWO DIMENSIONS (the second added 2026-07-26):
     SIZE        cfg.links[0]  joins a 4XL/5XL backing product onto the S-3XL primary so one
                               page sells S-5XL (ops/scripts/link_products.py).
     FRONT PRINT cfg.addon     joins the hidden front+back "add-on" products onto a BACK-ONLY
                               primary, so the front scripture print is a paid tick-box
                               (ops/scripts/front_print_option.py).
   Resolution is a flat lookup, checked in that priority: add-on ticked -> addon.variant_map,
   else an extended size -> links[0].variant_map, else the primary's own variant. Price,
   availability and media always come off the RESOLVED variant, so the add-on's +$6.99 is
   correct in every market with no client-side arithmetic. A product whose metafield has no
   `addon` key behaves exactly as it did before, which is what leaves the untagged catalogue
   untouched.

   Rise uses Dawn's <variant-selects> web component, which only knows the primary product's
   variants and asynchronously reverts any unknown (linked) value. Fighting it per-event is
   fragile, so we UNWRAP it: replace the custom element with a plain container (keeping its
   styled radios) so Dawn's controller detaches, then we own selection entirely, resolving each
   (colour, size, add-on) to the right product's variant and setting the form's hidden variant
   id, price, availability, and product media directly. Fully defensive: any failure leaves the
   native page working, and the add-on control stays hidden until it is proven wireable.
   See docs/superpowers/specs/2026-07-20-linked-products-design.md */
(function () {
  'use strict';
  window.LINKED_PRODUCTS = 'own-picker-v8-addon';
  var el = document.getElementById('linked-products-config');
  if (!el) return;
  var cfg;
  try { cfg = JSON.parse(el.textContent); } catch (e) { return; }
  var link = (cfg.links || [])[0];
  if (!link || !cfg.extends_option) return;
  var OPT = cfg.extends_option;
  var ADDS = link.adds_values || [];
  var VMAP = link.variant_map || {};
  var ADDON = (cfg.addon && cfg.addon.variant_map) ? cfg.addon : null;
  var AMAP = ADDON ? ADDON.variant_map : {};
  var GROUP = null;
  var primaryData = null, backingData = null;
  var addonById = {};          // add-on variant id -> variant object (both add-on products)
  var addonReady = false;
  var addonWrap = null, addonBox = null, addonDelta = null;

  function nm(node) { return (node && node.name ? node.name : '').trim(); }
  function isOptionGroup(name) { return /-\d+$/.test(name); }
  function radios() { return Array.prototype.slice.call(document.querySelectorAll('input[type="radio"]')); }
  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  ready(function () { try { init(); } catch (e) { if (window.console) console.warn('[linked-products]', e); } });

  function init() {
    var form = document.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return;
    var idInput = form.querySelector('input[name="id"]');
    if (!idInput) return;
    var vs = document.querySelector('variant-selects');
    var sizeRadios = radios().filter(function (i) { return nm(i).indexOf(OPT + '-') === 0; });
    if (!sizeRadios.length) return;
    GROUP = nm(sizeRadios[0]);

    addonWrap = document.querySelector('[data-fpo]');
    addonBox = document.querySelector('[data-fpo-toggle]');
    addonDelta = document.querySelector('[data-fpo-delta]');

    var primaryUrl = (vs && vs.dataset && vs.dataset.url) || null;
    var jobs = [
      fetch('/products/' + link.backing_handle + '.js').then(rjson).then(function (d) { backingData = d; }).catch(noop)
    ];
    if (primaryUrl) jobs.push(fetch(primaryUrl + '.js').then(rjson).then(function (d) { primaryData = d; }).catch(noop));
    (ADDON && ADDON.handles ? ADDON.handles : []).forEach(function (h) {
      jobs.push(fetch('/products/' + h + '.js').then(rjson).then(function (d) {
        if (!d || !d.variants) return;
        d.variants.forEach(function (v) { addonById[String(v.id)] = v; });
      }).catch(noop));
    });

    Promise.all(jobs).then(function () {
      injectValues(sizeRadios[0], sizeRadios);
      unwrap(vs);                       // detach Dawn from the picker
      enableAddon();
      bind(form, idInput);
      applyFromSelection(form, idInput); // set initial state
    });
  }

  function rjson(r) { return r.ok ? r.json() : null; }
  function noop() {}

  /* The add-on control stays hidden unless EVERY mapped variant actually resolved. A tick
     box that cannot deliver the print it charges for is worse than no tick box at all. */
  function enableAddon() {
    if (!ADDON || !addonWrap || !addonBox) return;
    var keys = Object.keys(AMAP);
    if (!keys.length) return;
    for (var i = 0; i < keys.length; i++) {
      if (!addonById[String(AMAP[keys[i]])]) return;
    }
    addonReady = true;
    addonWrap.removeAttribute('hidden');
  }

  function injectValues(proto, sizeRadios) {
    var container = proto.closest('fieldset') || proto.parentNode;
    var existing = {};
    sizeRadios.forEach(function (r) { existing[r.value] = 1; });
    var protoLabel = proto.id ? document.querySelector('label[for="' + CSS.escape(proto.id) + '"]') : null;
    ADDS.forEach(function (val) {
      if (existing[val]) return;
      var input = proto.cloneNode(false);
      input.value = val; input.checked = false; input.removeAttribute('checked');
      input.classList.remove('disabled');
      input.id = (proto.id || 'linked') + '-linked-' + val.replace(/\W+/g, '');
      input.setAttribute('data-linked', '1');
      container.appendChild(input);
      if (protoLabel) {
        var label = protoLabel.cloneNode(true);
        label.setAttribute('for', input.id);
        var span = label.querySelector('span:not(.visually-hidden)') || label;
        span.textContent = val;
        container.appendChild(label);
      }
    });
  }

  function unwrap(vs) {
    if (!vs || !vs.parentNode) return;
    var div = document.createElement('div');
    div.className = vs.className;
    while (vs.firstChild) div.appendChild(vs.firstChild);
    vs.parentNode.replaceChild(div, vs);
  }

  function bind(form, idInput) {
    document.addEventListener('change', function (e) {
      if (!e.target) return;
      if (addonReady && e.target === addonBox) { applyFromSelection(form, idInput, true); return; }
      var n = nm(e.target);
      if (n === GROUP || isOptionGroup(n)) applyFromSelection(form, idInput);
    });
  }

  function checkedValue(groupName) {
    var found = null;
    radios().forEach(function (i) { if (i.checked && nm(i) === groupName) found = i.value; });
    return found;
  }

  function otherValues() {
    var others = [];
    radios().forEach(function (i) {
      if (!i.checked) return;
      var n = nm(i);
      if (n && n !== GROUP && isOptionGroup(n)) others.push(i.value);
    });
    return others;
  }

  function primaryVariants() {
    try { return window.ShopifyAnalytics.meta.product.variants || []; } catch (e) { return []; }
  }

  function addonOn() { return !!(addonReady && addonBox && addonBox.checked); }

  /* Resolve a (colour, size) pair, optionally with the front print added, to the variant that
     must actually go in the cart. withAddon is passed explicitly rather than read off the
     checkbox so the price delta can price both states at once. */
  function resolve(color, size, withAddon) {
    var key = color ? (color + ' / ' + size) : size;
    if (withAddon) {
      var av = addonById[String(AMAP[key])];
      if (!av) return null;
      return { id: av.id, price: av.price, available: av.available, media: av.featured_media };
    }
    if (ADDS.indexOf(size) !== -1) {
      var vid = VMAP[key];
      if (!vid) return null;
      var bv = backingData && backingData.variants
        ? backingData.variants.filter(function (v) { return String(v.id) === String(vid); })[0] : null;
      return { id: vid, price: bv ? bv.price : null, available: bv ? bv.available : true, media: bv ? bv.featured_media : null };
    }
    // native size: id + price from ShopifyAnalytics meta (works even for a draft/unpublished
    // primary); enrich availability + media from the primary .js when it loads (active product).
    var mv = primaryVariants().filter(function (v) { return (v.public_title || '') === key; })[0];
    if (!mv) return null;
    var res = { id: mv.id, price: mv.price, available: true, media: null };
    if (primaryData && primaryData.variants) {
      var pv = primaryData.variants.filter(function (v) { return String(v.id) === String(mv.id); })[0];
      if (pv) { res.available = pv.available; res.media = pv.featured_media; }
    }
    return res;
  }

  function applyFromSelection(form, idInput, addonToggled) {
    var size = checkedValue(GROUP);
    if (size === null) return;
    var others = otherValues();
    var color = others.length ? others[0] : null;
    var on = addonOn();
    var v = resolve(color, size, on);
    if (!v && on && addonBox) {          // never strand the buyer on a dead add-on combination
      addonBox.checked = false; on = false; v = resolve(color, size, false);
    }
    var btn = form.querySelector('[name="add"], .product-form__submit');
    updateDelta(color, size);
    if (!v) { setBtn(btn, false, 'Unavailable'); idInput.setAttribute('disabled', 'disabled'); return; }
    idInput.value = v.id;
    if (v.available === false) { idInput.setAttribute('disabled', 'disabled'); setBtn(btn, false, 'Sold out'); }
    else { idInput.removeAttribute('disabled'); setBtn(btn, true, 'Add to cart'); }
    if (v.price != null) updatePrice(v.price);
    // On a deliberate tick, show the buyer the print they just paid for; on untick, go back to
    // the base view. Selecting a colour still swaps to that colour's media as before.
    if (addonToggled) showAddonMedia(on, v);
    else if (v.media) swapMedia(v.media);
  }

  /* "+ $6.99", priced from the two resolved variants rather than a hard-coded number, so the
     figure stays honest in every market and after any ladder change. */
  function updateDelta(color, size) {
    if (!addonDelta) return;
    var base = resolve(color, size, false);
    var plus = resolve(color, size, true);
    if (!base || !plus || base.price == null || plus.price == null) { addonDelta.textContent = ''; return; }
    var d = plus.price - base.price;
    addonDelta.textContent = d > 0 ? '+ ' + formatMoney(d) : '';
  }

  function setBtn(btn, enabled, text) {
    if (!btn) return;
    if (enabled) btn.removeAttribute('disabled'); else btn.setAttribute('disabled', 'disabled');
    var t = btn.querySelector('span');
    if (t && text && /add to cart|sold out|unavailable/i.test(t.textContent)) t.textContent = text;
  }

  function updatePrice(cents) {
    var target = document.querySelector('.price__regular .price-item--regular, .price-item--regular, .price .money');
    if (target) target.textContent = formatMoney(cents);
  }

  /* The gallery slide whose alt text names the add-on is the one image showing the paid front
     print (composed by ops/scripts/compose_mockups.py with a burnt-in banner). Found by alt so
     no media id has to be carried in the metafield. */
  function addonSlide() {
    var g = document.querySelector('media-gallery');
    if (!g) return null;
    var slides = Array.prototype.slice.call(g.querySelectorAll('[data-media-id]'));
    for (var i = 0; i < slides.length; i++) {
      var img = slides[i].querySelector('img');
      var alt = (img && img.getAttribute('alt')) || '';
      if (/front print add-?on/i.test(alt)) return slides[i];
    }
    return null;
  }

  function showAddonMedia(on, v) {
    var slide = on ? addonSlide() : null;
    if (slide) { activate(slide); return; }
    if (v && v.media) swapMedia(v.media);
  }

  function activate(slide) {
    /* NEVER move the viewport (operator, 2026-07-26): being dragged back up to the gallery
       at the exact moment the buyer has decided to add the front print takes them AWAY from
       the buy button. By then they have already seen the image, so the media swap is for
       anyone who scrolls back up, never a reason to hijack the scroll.

       WHERE THE SCROLL ACTUALLY COMES FROM (traced on the live page 2026-07-26, after two
       fixes aimed at the wrong thing): Rise's assets/media-gallery.js setActiveMedia calls
       *** window.scrollTo({top: N, behavior: 'smooth'}) *** directly. It is NOT
       Element.scrollIntoView, so stubbing scrollIntoView changed nothing, and because the
       scroll is a SMOOTH animation running for ~2s, pinning the position on 0/80/250ms
       timers loses to the frames that follow (measured at 390px: 1887 -> 176, a 1711px
       jump, Add to cart pushed 1711px off screen). Frame-by-frame pinning would stutter.

       So the animation is never allowed to start: window.scrollTo/scroll are suppressed for
       the setActiveMedia call and a short tail (the call scrolls from inside a setTimeout),
       then restored. The scrollIntoView stub is kept as a cheap guard in case a theme
       update moves the scroll back to the Dawn implementation. */
    try {
      var g = document.querySelector('media-gallery');
      if (!g || typeof g.setActiveMedia !== 'function') return;
      var slides = Array.prototype.slice.call(g.querySelectorAll('[data-media-id]'));
      slides.forEach(function (el) { el.scrollIntoView = function () {}; });
      var origTo = window.scrollTo, origScroll = window.scroll, suppress = true;
      window.scrollTo = function () { if (!suppress) return origTo.apply(window, arguments); };
      window.scroll = function () { if (!suppress) return origScroll.apply(window, arguments); };
      var restore = function () {
        suppress = false;
        window.scrollTo = origTo;
        window.scroll = origScroll;
        slides.forEach(function (el) { delete el.scrollIntoView; });
      };
      try {
        g.setActiveMedia(slide.dataset.mediaId, false);
      } finally {
        setTimeout(restore, 600);   // long enough for the theme's deferred scroll, short
      }                             // enough that a real user scroll is never swallowed
    } catch (e) {}
  }

  function swapMedia(media) {
    try {
      var id = (media && (media.id || media)) || null;
      if (!id) return;
      var g = document.querySelector('media-gallery');
      if (!g) return;
      var slide = g.querySelector('[data-media-id$="-' + id + '"]');
      if (slide) activate(slide);
    } catch (e) {}
  }

  /* Currency comes from the ACTIVE market, not from the product payload. /products/x.js
     does not return price_currency, so the old code always fell through to its 'AUD'
     default and rendered a US buyer's correct 29.99 as "A$29.99" (pre-existing since v7,
     caught on the first front-print verification 2026-07-26). window.Shopify.currency.active
     is the presentment currency the prices in that payload are already denominated in. */
  function formatMoney(cents) {
    try {
      var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active)
        || (backingData && backingData.variants && backingData.variants[0] && backingData.variants[0].price_currency)
        || 'AUD';
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur }).format(cents / 100);
    } catch (e) { return '$' + (cents / 100).toFixed(2); }
  }
})();
